import React from "react";
import { Grid, MenuItem } from "@mui/material";
import { useTranslation } from "react-i18next";

import { Error } from "../../../../../models/error";
import { User } from "../../../../../models/user";
import { UserDateFormatOptions, UserTimeFormatOptions } from "../../../../../util/enums";
import Select from "../../../../Form/Select";
import SkeletonComponent from "../../../Skeleton";

interface Props {
  view: boolean;
  isLoading: boolean;
  userForm: User | null;
  getErrorByField: (value: string) => string | undefined;
  updateOrCreate: (attribute: string, value: any) => void;
  errorResponse?: Error;
}

const UserPreferencesComponent = ({
  view,
  isLoading,
  userForm,
  getErrorByField,
  updateOrCreate,
}: Props) => {
  const { t: translate } = useTranslation();

  const dateFormatOptions = [
    {
      value: UserDateFormatOptions.DD_MM_YYYY,
      label: "DD/MM/YYYY",
    },
    {
      value: UserDateFormatOptions.MM_DD_YYYY,
      label: "MM/DD/YYYY",
    },
  ];

  const timeFormatOptions = [
    {
      value: UserTimeFormatOptions.TWENTY_FOUR_HOUR,
      label: "24-hour format (e.g., 18:30)",
    },
    {
      value: UserTimeFormatOptions.TWELVE_HOUR,
      label: "12-hour format (AM/PM – e.g., 6:30 PM)",
    },
  ];

  const handleChangePreference = (
    field: "dateFormat" | "timeFormat",
    value: UserDateFormatOptions | UserTimeFormatOptions
  ) => {
    updateOrCreate("preferences", {
      ...userForm?.preferences,
      [field]: value,
    });
  };

  return (
    <Grid container spacing={2}>
      <Grid item xs={12} sm={6} md={4}>
        <SkeletonComponent isLoading={isLoading}>
          <Select
            disabled={view}
            label={translate("dateFormat")}
            name="dateFormat"
            placeholder={translate("selectAnOption")}
            value={userForm?.preferences?.dateFormat || UserDateFormatOptions.DD_MM_YYYY}
            error={!!getErrorByField("preferences.dateFormat")}
            errorMessage={getErrorByField("preferences.dateFormat")}
            onChange={(event) =>
              handleChangePreference("dateFormat", event.target.value as UserDateFormatOptions)
            }
          >
            {dateFormatOptions.map(({ value, label }) => (
              <MenuItem key={value} value={value}>
                {label}
              </MenuItem>
            ))}
          </Select>
        </SkeletonComponent>
      </Grid>

      <Grid item xs={12} sm={6} md={4}>
        <SkeletonComponent isLoading={isLoading}>
          <Select
            disabled={view}
            label={translate("timeFormat")}
            name="timeFormat"
            placeholder={translate("selectAnOption")}
            value={userForm?.preferences?.timeFormat || UserTimeFormatOptions.TWENTY_FOUR_HOUR}
            error={!!getErrorByField("preferences.timeFormat")}
            errorMessage={getErrorByField("preferences.timeFormat")}
            onChange={(event) =>
              handleChangePreference("timeFormat", event.target.value as UserTimeFormatOptions)
            }
          >
            {timeFormatOptions.map(({ value, label }) => (
              <MenuItem key={value} value={value}>
                {label}
              </MenuItem>
            ))}
          </Select>
        </SkeletonComponent>
      </Grid>
    </Grid>
  );
};

export default UserPreferencesComponent;
